// Page translations (Thai)
export const PAGE_TRANSLATIONS = {
  // Common elements
  SAVE: 'บันทึก',
  CANCEL: 'ยกเลิก',
  ACTIONS: 'การกระทำ',
  NAME: 'ชื่อ',
  TELEPHONE: 'โทรศัพท์',
  ADDRESS: 'ที่อยู่',
  DESCRIPTION: 'รายละเอียด',
  DELETE_CONFIRM_CUSTOMER: 'คุณแน่ใจหรือว่าต้องการลบลูกค้ารายนี้?',
  DELETE_CONFIRM_PRODUCT: 'คุณแน่ใจหรือว่าต้องการลบสินค้านี้?',

  // Page titles
  CUSTOMERS: 'ลูกค้า',
  PRODUCTS: 'สินค้า',

  SEARCH: 'ค้นหา',
  START_DATE: 'วันที่เริ่มต้น',
  END_DATE: 'วันที่สิ้นสุด',
  HEAD_LICENSE_PLATE: 'ทะเบียนรถหน้า',
  TAIL_LICENSE_PLATE: 'ทะเบียนรถท้าย',
  TRUCK_WEIGHT: 'น้ำหนักรถบรรทุก',
  WEIGHT: 'น้ำหนัก',
  NET_WEIGHT: 'น้ำหนักสุทธิ',
  DATE: 'วันที่',
  WEIGHED_BY: 'ชั่งโดย',
  NO_DATA: 'ไม่มีข้อมูล',

  CODE: 'รหัส',
  PRODUCT_NAME: 'ชื่อสินค้า',
  CUSTOMER_NAME: 'ชื่อลูกค้า',
  ALL_LICENSE_PLATE: 'ทะเบียนรถ (หน้า/ท้าย)',
  LICENSE_PLATE: 'ทะเบียนรถ',
  ALL_CUSTOMERS: 'ลูกค้าทั้งหมด',
  ALL_PRODUCTS: 'สินค้าทั้งหมด',

  PAGE: 'หน้า',
  DASHBOARD: 'แดชบอร์ด',
  PRODUCT_WEIGHT: 'น้ำหนักสินค้า',
  LOGOUT: 'ออกจากระบบ',
  
  BILL_CODE_PLACEHOLDER: 'รหัสอ้างอิง',
  OFFICIAL_CODE: 'รหัสอ้างอิง',
  BALANCE: 'ยอดเงิน',
  TAX_BALANCE: 'ภาษี',
  TOTAL: 'รวม',
  BILLS: 'บิล',
  
  // Dashboard page translations
  WELCOME: 'ยินดีต้อนรับ',
  APPLY_FILTER: 'ใช้ตัวกรอง',
  QUICK_STATS: 'สถิติเบื้องต้น',
  TOTAL_COUNT: 'จำนวนทั้งหมด',
  TOTAL_WEIGHT: 'น้ำหนักรวม',
  DAILY_STATISTICS: 'สถิติรายวัน',
  COUNT: 'จำนวน',
  WEIGHT_KG: 'น้ำหนัก (กก.)',
  NO_DAILY_STATS: 'ไม่มีข้อมูลสถิติรายวันสำหรับช่วงเวลาที่เลือก',
  TOP_CUSTOMERS: 'ลูกค้าชั้นนำ',
  NO_CUSTOMER_DATA: 'ไม่มีข้อมูลลูกค้า',
  TOP_PRODUCTS: 'สินค้าชั้นนำ',
  NO_PRODUCT_DATA: 'ไม่มีข้อมูลสินค้า',
  PERIOD_OVERVIEW: 'ภาพรวมช่วงเวลา',
  SHOWING_DATA_FROM: 'แสดงข้อมูลตั้งแต่',
  TO: 'ถึง',
  DAYS_OF_ACTIVITY: 'วันที่มีกิจกรรม',
  NO_ACTIVITY: 'ไม่มีกิจกรรมในช่วงเวลานี้',
  ITEMS: 'รายการ',
  KG: 'กก.'
}; 